export interface Config {
  production: false;
  apiUrl: '';
  captchaKey: string;
  dealerTypeId: number;
  userInactivityMinutes: number;
  userInactivityResponseSeconds: number;
  passwordMinLength: number;
}
export const environmentBase = {
  captchaKey: '6LdVqG4gAAAAABPTSIocqqnK14DyV72U8ieKjRpN',
  passwordMinLength: 12,
};
